import React, {Component} from 'react';

const ListItem = ({itemName, itemAmount}) => (
	<li className="gcAd-gift-item"
	>{itemName} x {itemAmount}</li>
)

class Gift extends Component {
	render() {
		const itemsList = this.props.ItemsList;
		const {code, redeemButton, title, link} = this.props;

		return (
			<section id="sgSectionGift" className="gcAd-section game-gift" data-section="4">
				<div id="sgGiftTitle" className="gcAd-gift-title">
					{title}
				</div>
				<div id="sgGift" className="gcAd-gift">
					<div className="gcAd-gift-img">

					</div>
					<ul className="gcAd-gift-items">
						{itemsList.map(item => <ListItem
							key={Object.keys(itemsList)[itemsList.indexOf(item)]}
							itemName={item.ItemName}
							itemAmount={item.Amount}
						/>)}
					</ul>
					<div className="gcAd-gift-info">
						<div className="gcAd-gift-code gcAd-gift-btn">
							{code}
						</div>
						<a href={link}>
							<div className="gcAd-gift-redeem-site gcAd-gift-btn">
								{redeemButton}
							</div>
						</a>
					</div>
				</div>
			</section>
		)
	}
}

export default Gift;


// WEBPACK FOOTER //
// ./src/Components/Advert-Gift.js